import { makeFailure, makeSuccess, TResult } from "../../../../../sg-core";
import ICategory from "../../ICategory";
import IFormType from "../../IFormType";
import IObservation from "../../IObservation";
import { EObservationPackageVersio } from "../ObservationPackage"


type V1Observation = IObservation;
type V1Category = ICategory;
type V1FormType = IFormType;



//
//  Package content
//
export interface IObservationPackageV1 {
    versio: EObservationPackageVersio.v1;
    observation: V1Observation;
    formType: V1FormType;
    category: V1Category;
};

//
// Content validator
//

export const validateObservationPackageV1 = (uknownData: Partial<IObservationPackageV1>): TResult<IObservationPackageV1> => {
    try {
        if (!uknownData.observation || !uknownData.observation.id) throw new Error("Missing observation");
        //  if (!uknownData.formType || !uknownData.formType.id) throw new Error("Missing formType");
        // if (!uknownData.category || !uknownData.category.id) throw new Error("Missing category");

        const permitPackage = uknownData as IObservationPackageV1;

        return makeSuccess(permitPackage);
    } catch (error) {
        console.info("[validatePermitPackageV1]", { uknownData })
        console.info(error)
        return makeFailure(error as Error);
    };
};
